import { render, staticRenderFns } from "./AlphabeticalFacet.vue?vue&type=template&id=38ca4898&"
import script from "./AlphabeticalFacet.vue?vue&type=script&lang=js&"
export * from "./AlphabeticalFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports